import { tableLabels } from '../constants'
import {
  TableActionsCreator,
  TABLE_ACTIONS_TYPE,
  TABLE_ACTION_COMPONENTS
} from '@ublique/components'
import { ModalActions } from '@ublique/platform'

import {
  getUserPreferences,
  updateUserDataPreferences
} from '@ublique/platform/services/api/user'
import { userPreferencesStore } from '@ublique/platform/services/state'

export const defaultColDef = {
  filter: true,
  resizable: true,
  sortable: true
}

/* export const getFilterModelFromSelection = (selected) => {
  if (!selected?.length) {
    return {}
  }

  const filterBody = {
    filterType: 'set',
    type: 'in',
    values: selected.map((row) => row.id)
  }

  return { id: filterBody }
} */

export const getColumnDefs = (t) => {
  const columns = [
    {
      headerName: t(tableLabels.STORE),
      field: 'ente',
      colId: 'ente',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.ZONE),
      field: 'zona',
      colId: 'zona',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.ARTICLE),
      field: 'articolo',
      colId: 'articolo',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.CATEGORY),
      field: 'category',
      colId: 'category',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.SUBCATEGORY),
      field: 'subcategory',
      colId: 'subcategory',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.APC),
      field: 'apc',
      colId: 'apc',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.SEASON),
      field: 'stagione',
      colId: 'stagione',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.FUNCTION),
      field: 'funzione',
      colId: 'funzione',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.CLUSTER),
      field: 'cluster',
      colId: 'cluster',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.HYP),
      field: 'hyp',
      colId: 'hyp',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.ACTION),
      field: 'action',
      colId: 'action',
      filter: 'agSetColumnFilter'
    },
    {
      headerName: t(tableLabels.QUANTITY),
      field: 'qty',
      colId: 'qty',
      filter: 'agNumberColumnFilter',
      cellStyle: { textAlign: 'right' },
      enableValue: true
    },
    {
      headerName: t(tableLabels.VALUE),
      field: 'valore',
      colId: 'value',
      filter: 'agNumberColumnFilter',
      valueFormatter: function (params) {
        if (isNaN(params.value)) return ''

        const formattedValue = new Intl.NumberFormat('it-IT', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(params.value)
        // Your formatting logic here, for example, formatting to two decimal places
        return formattedValue
      },
      cellStyle: { textAlign: 'right' },
      enableValue: true
    }
  ]

  return columns.map((coldef) => ({
    ...coldef,
    enableRowGroup: true,
    enablePivot: true
  }))
}

export const tableActionsConfig = ({
  btnFilterT,
  gridApi,
  t,
  isActiveTabular,
  setIsActiveTabular,
  enableFilterBtn,
  filterName
}) => {
  const { openModal } = ModalActions

  const builder = new TableActionsCreator() //

  if (filterName) {
    builder.addUbliqueBtn({
      type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
      action: () => {},
      componentProps: {
        t: btnFilterT,
        filterName,
        component: TABLE_ACTION_COMPONENTS.ShowActiveNameFilter
      }
    })
  }

  //add
  builder.addUbliqueBtn({
    type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
    action: () => {},
    componentProps: {
      openModal: openModal,
      updateUserDataPreferences: updateUserDataPreferences,
      userPreferences: getUserPreferences,
      ...enableFilterBtn,
      component: TABLE_ACTION_COMPONENTS.ColumnsFilterButtonTable
    }
  })

  builder.addUbliqueBtn({
    type: TABLE_ACTIONS_TYPE.PLATFORM_COMPONENTS,
    action: () => {},
    componentProps: {
      t: btnFilterT,
      gridApi,
      isActiveTabular,
      setIsActiveTabular,
      component: TABLE_ACTION_COMPONENTS.TabularButton
    }
  })

  return builder.getTableButtons()
}
export const findAndSetAppliedFilter = (params) => {
  const pageUserConfig =
    userPreferencesStore.get().output?.filteredOutputColumns['detail_pivot'] ??
    []

  const pageUserConfigSelected = pageUserConfig?.find(
    ({ selected }) => selected
  )
  if (pageUserConfigSelected) {
    if (pageUserConfigSelected?.tabular) {
      params.api.gridCore.gridOptions.groupDefaultExpanded = 5
      params.api.gridCore.gridOptions.groupHideOpenParents = true
    }
    const model = pageUserConfigSelected?.model

    params?.api?.gridCore?.columnApi?.resetColumnState()
    params?.api?.gridCore?.columnApi?.setColumnState(model)

    const pivotFilterInfo = pageUserConfigSelected?.filter
    if (pivotFilterInfo) {
      params.api.gridCore.filterManager.setFilterModel(pivotFilterInfo)
      params.api.gridCore.filterManager.onFilterChanged()
    }
  }
}
